var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 14.1663L17.5 9.99961M17.5 9.99961L13.3333 5.83294M17.5 9.99961H7.5M10 14.1663C10 14.4126 10 14.5357 9.99085 14.6424C9.89569 15.7512 9.07905 16.6636 7.98753 16.8807C7.88252 16.9015 7.76001 16.9152 7.51529 16.9424L6.66412 17.0369C5.3854 17.179 4.74601 17.25 4.23805 17.0875C3.56078 16.8708 3.00785 16.3759 2.71765 15.7267C2.5 15.2398 2.5 14.5965 2.5 13.3099V6.68935C2.5 5.40274 2.5 4.75944 2.71765 4.27254C3.00785 3.62334 3.56078 3.12844 4.23805 2.91171C4.74601 2.74916 5.38538 2.8202 6.66412 2.96229L7.51529 3.05686C7.7601 3.08406 7.8825 3.09766 7.98753 3.11854C9.07905 3.33557 9.89569 4.24797 9.99085 5.35678C10 5.46347 10 5.58662 10 5.83294",
    stroke: "#EBEBF5",
    strokeOpacity: 0.64,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.a3c8f5e43849a3eddf6d2b5a2c719af8.svg";
export { ForwardRef as ReactComponent };